import { EventBus } from '@/event-bus';
import Vue from 'vue';

export default Vue.extend({
  methods: {
    closeModal(template): void {
      EventBus.$emit('closeModal', template);
    },
  },
});
